let loginMyPage = (function () {
  let fn,
    recruitNoticeList = [],
    interval,
    jfYn = false,
    jdYn = false;
  let secretJobNotice = false;
  const captcha = $('#tblCaptcha').captcha({});

  const jobdaFn = (() => {
    let jobdaLoginWindow = null;
    const jobdaDomain = $('#jobdaDomain').val().trim();
    const loadJobdaUserProfile = (accessToken) => {
      const param = {
        accessToken: accessToken,
      };

      // 잡다에 사용자 정보 조회 API
      $.ajax({
        type: 'post',
        dataType: 'json',
        beforeSend: Common.loading.show(),
        url: '/app/applicant/getJobdaUserInfoForMyPage',
        async: false,
        data: param,
      })
        .always(Common.loading.countHide)
        .fail(Common.ajaxOnfail)
        .done(function (data, e) {
          const { name, email } = data;

          // 사용자 정보 DOM에 삽입
          $('#name').val(name);
          $('#email').val(email);
        });
    };

    const init = () => {
      window.addEventListener('message', jobdaLoginMessageFn);
    };

    const jobdaLoginPopup = () => {
      // message를 받아야하는 현재 url만 보낸다.
      const messageUrl = window.location.href;

      // JOBDA에서 resume이면 지원서 작성&수정으로 인식하고 mypage면 마이페이지로 인식함
      const PAGETYPE = 'mypage';

      jobdaLoginWindow = window.open(
        `${jobdaDomain}/jobflex/login?messageUrl=${messageUrl}&type=${PAGETYPE}`,
        '_blank',
        'width=1200, height=1200',
      );

      return jobdaLoginWindow;
    };

    const jobdaLoginMessageFn = (event) => {
      if (event.origin === jobdaDomain) {
        // 이미 잡다 탈퇴회원인 경우 잡다 로그인 페이지 밑에 있는 링크를 눌러서 잡다 로그인 창을 끄고 알아서 정보 입력해서 확인할 수 있게 한다.
        if (event.data.isJobdaClose) {
          jobdaLoginWindow.close();
        }
        if (event.data.accessToken) {
          jobdaLoginWindow.close();
          loadJobdaUserProfile(event.data.accessToken);
        }
      }
    };

    return {
      init,
      jobdaLoginPopup,
    };
  })();

  fn = {
    init() {
      //#5626 상단 헤더명칭 불러오기
      $.ajax({
        type: 'post',
        dataType: 'json',
        url: '/appsite/company/getMainView',
        data: {
          appsiteSn: $('#_appsiteSn').val(),
          settingType: $('#_settingType').val(),
        },
        async: false,
      }).done(function (data, e) {
        let myPageMenuName = (
          D.arrToObj(
            'menuCode',
            (
              D.arrToObj('menuCode', data.menuList)[2000] || {
                childMenuList: [],
              }
            ).childMenuList,
          )[2800] || { menuName: '안내 및 발표확인' }
        ).menuName;
        $('head>title').html(myPageMenuName); // 헤드 수정
        $('h1.recruitNoticeTitle').text(myPageMenuName);
      });

      jobdaFn.init();
      fn.load();
      fn.event();
    },
    load() {
      let param = {};
      $('#loginForm').html(fn.template());
      if (D.param['jobnoticeSn']) {
        // jobnoticeSn을 파라미터로 받은경우 마이페이지에 공고가 선택되어있음
        param.jobnoticeSn = D.param['jobnoticeSn'];
        param.systemKindCode = D.param['systemKindCode'];
        secretJobNotice = true;
        $.ajax({
          type: 'post',
          dataType: 'json',
          beforeSend: Common.loading.show(),
          url: '/app/applicant/getJobnotice',
          async: false,
          data: param,
        })
          .always(Common.loading.countHide)
          .fail(Common.ajaxOnfail)
          .done(function (data) {
            fn.loadRecruitNotice(data);
          });
      } else {
        param.applicantActionCode = 'MYPAGE';
        $.ajax({
          type: 'post',
          dataType: 'json',
          beforeSend: Common.loading.show(),
          url: '/app/applicant/getJobnoticeList',
          async: false,
          data: param,
        })
          .always(Common.loading.countHide)
          .fail(Common.ajaxOnfail)
          .done(function (x, e) {
            recruitNoticeList = x;
            fn.loadRecruitNoticeList();
          });
      }
    },
    event() {
      // like-select 활성화
      $('div.like-select>button').click(function () {
        if ($(this).hasClass('active')) $(this).removeClass('active');
        else {
          $(this).addClass('active');
          $(this).next('div').find('input[type="search"]').focus();
        }
      });

      // like-select 닫기
      $(document).on('mousedown', function (e) {
        if (!$(e.target).closest('div.like-select').size()) {
          $('div.like-select>button.active').removeClass('active');
        }
      });

      // like-select 선택
      $('div.like-select>button+div button').click(function () {
        let name, $wrap, value, systemKindCode, resumeType;
        ($wrap = $(this).closest('div.like-select[data-name]')),
          (name = $wrap.attr('data-name')),
          (value = $(this).attr('data-value')),
          (systemKindCode = $(this).attr('data-systemKindCode')),
          (resumeType = $(this).attr('data-resumetype'));

        //구공고가 아니면 신규 지원서 마이페이지로 리다이렉팅
        if (resumeType !== 'BASIC')
          window.location.href = `/v1/applicant/my-page/login?jobnoticeSn=${value}&systemKindCode=${systemKindCode}`;

        jfYn = D.bool($(this).attr('data-jobflex'));
        jdYn = $(this).attr('data-contractsubjecttype') === 'JOBDA';
        if (!name) throw new Error('like-select에 data-name을 추가하세요.');
        if (!$wrap.find(`input[name="${name}"]`).size())
          throw new Error(`적용할 input이 없습니다. : ${name}`);

        const isJF3MemberJobNotice =
          $(this).data('contractsubjecttype') === 'JOBDA';
        const isRecommendAndPrivateJobnotice =
          $(this).data('recruittypecode') === 'RECOMMEND' ||
          $(this).data('recruittypecode') === 'PRIVATE';

        // NOTE: 24.08.05 마이페이지에서 공고 선택 시 잡다 로그인 뜨는 거 제거 요청에 따른 임시 주석처리 (언제 복구할지 모름)
        // JF3인 공고인데 추천 및 비공개 공고가 아닐 때
        // if (isJF3MemberJobNotice && !isRecommendAndPrivateJobnotice) {
        //   jobdaFn.jobdaLoginPopup();
        // } else {
        //   $('#name').val('');
        //   $('#email').val('');
        // }

        $wrap
          .find('>button')
          .text($(this).text())
          .attr('title', $(this).text()); // 텍스트 업데이트
        $wrap.find(`input[name="${name}"]`).val(value); // value 업데이트

        $(document).mousedown(); // like-select 닫기
        $('#jobnoticeSn').val(value);
        $('#systemKindCode').val(systemKindCode);
      });

      // like-select 키워드 검색
      $('div.like-select input[type="search"]')
        .focus(function (e) {
          let oldKeyword = this.value,
            _this = this,
            $list = $(this).next('ul').find('button');
          interval = setInterval(function () {
            let keyword = _this.value;
            if (oldKeyword === keyword) return;
            oldKeyword = keyword;
            $list.each(function () {
              let title = $(this).attr('title');
              if (keyword === '') $(this).show();
              else if (title.indexOf(keyword) < 0) $(this).hide();
              else $(this).show();
            });
          }, 200);
        })
        .blur(function (e) {
          clearInterval(interval);
        })
        .keydown(function (e) {
          if (e.keyCode === 13) return false;
        });

      // 비밀번호 찾기
      $('button[data-button="findPassword"]').click(function () {
        FindPassword.init();
      });

      // 로그인 버튼 클릭
      $('#frm').submit(fn.submit);
    },
    // 지원서 작성
    submit(e) {
      let result = true;

      const selectNoticeName = $('[type="button"]').attr('title');

      if (!selectNoticeName && !secretJobNotice) {
        // 선택된 공고가 없으면서 비공개채용이 아닐 때
        Alert('공고명을 선택해주세요.');
        result = false;
      }
      let status;

      status = $(this).attr('data-status');

      if (!captcha.getAnswer()) {
        Alert('보안문자를 입력해주세요.');
        return false;
      }

      // status가 submit이 아니면 모달을 띄우고 submit이면 정말로 넘긴다
      if (status !== 'submit') {
        e.preventDefault();

        const serializedArray = $('#frm').serializeArray();
        serializedArray.forEach((item) => {
          if (item.name === 'password') {
            item.value = RsaCommon.getEncPassword(item.value);
          }
        });

        $.ajax({
          type: 'post',
          dataType: 'json',
          beforeSend: Common.loading.show(),
          url: 'loginForMyPage',
          async: false,
          data: serializedArray,
        })
          .always(Common.loading.countHide)
          .fail(Common.ajaxOnfail)
          .done(function (x, e) {
            // 에러메세지가 넘어오면 중지
            if (x.message) {
              Alert(x.message);
              return false;
            }

            $.ajax({
              // 동의서 저장 하기 전에 세션얻기위해 로그인 해야함
              type: 'post',
              dataType: 'json',
              beforeSend: Common.loading.show(),
              url: '/app/applicant/checkCurrentPersonalInfoCollection',
              async: false,
              data: serializedArray,
            })
              .always(Common.loading.countHide)
              .fail(Common.ajaxOnfail)
              .done(function (data, e) {
                let {
                  insightAgreementLetterModifyYn,
                  jobdaAgreementLetterModifyYn,
                  isNotPrivateAndRecommend,
                } = data;

                //선택한 jobnoticeSn에 해당하는 Name도 같이 넘김
                $('#frm').append(
                  `<input type="hidden" name="jobnoticeName" value="${$(
                    'select[name="jobnoticeSn"] option:selected',
                  ).text()}">`,
                );

                const submitFn = () => {
                  $('#frm').attr({ 'data-status': 'submit' }).submit();
                };

                if (
                  insightAgreementLetterModifyYn ||
                  (jobdaAgreementLetterModifyYn && isNotPrivateAndRecommend)
                ) {
                  const modalAgreement = ModalAgreement(
                    $('#jobnoticeSn').val(),
                    'MRS2',
                    'MYPAGE',
                    jfYn,
                    insightAgreementLetterModifyYn,
                    jobdaAgreementLetterModifyYn,
                    () => {
                      let dataObj = {
                        jobnoticeSn: $('#jobnoticeSn').val(),
                        systemKindCode: 'MRS2',
                        agreementLetterSn: modalAgreement.agreementLetterSn,
                        agreementItemSnSet:
                          modalAgreement.agreementItemSnSet.join(),
                        applicantActionCode: 'MYPAGE',
                      };

                      if (jobdaAgreementLetterModifyYn) {
                        dataObj = {
                          ...dataObj,
                          agreementLetterSn: null,
                          agreementItemSnSet: null,
                          jobdaAgreementLetterSn:
                            modalAgreement.jobdaAgreementLetterSn,
                          jobdaAgreementLetterAgreeYn:
                            modalAgreement.jobdaAgreementLetterAgreeYn,
                        };
                      }

                      $.ajax({
                        type: 'post',
                        dataType: 'json',
                        beforeSend: Common.loading.show(),
                        url: '/app/applicant/saveCurrentPersonalInfoCollection',
                        async: false,
                        data: dataObj,
                      })
                        .always(Common.loading.countHide)
                        .fail(Common.ajaxOnfail)
                        .done(function (x, e) {
                          submitFn();
                        });
                    },
                    () => {
                      const modifyOnlyJobdaAgreementLetter =
                        jobdaAgreementLetterModifyYn &&
                        !insightAgreementLetterModifyYn;
                      if (modifyOnlyJobdaAgreementLetter) {
                        submitFn();
                      }
                    },
                  );
                } else {
                  submitFn();
                }
              });
          });
      }
      captcha.refresh();

      if (!result) {
        $(this).removeAttr('data-status');
      }

      return result;
    },
    loadRecruitNoticeList() {
      let t = [],
        d,
        i;
      t.push(
        '<input type="text" name="jobnoticeSn" id="jobnoticeSn" class="hidden" title="공고명" required />',
      );
      t.push(
        '<button type="button" class="ellipsis">공고명 선택하세요.</button>',
      );
      t.push('<div id="loadRecruitNotice">');
      t.push('	<input type="search" placeholder="검색" />');
      t.push('	<ul>');
      for (i = 0; i < recruitNoticeList.length; i++) {
        d = recruitNoticeList[i];
        t.push(
          `		<li><button type="button" class="ellipsis" data-systemKindCode="${d.systemKindCode}" data-value="${d.jobnoticeSn}" data-jobflex="${d.jobflexYn}" data-contractsubjecttype="${d.contractSubjectType}" data-recruittypecode='${d.recruitTypeCode}' title="${d.jobnoticeName}" data-resumetype="${d.resumeType}">${d.jobnoticeName}</button></li>`,
        );
      }
      t.push('	</ul>');
      t.push('</div>');
      $('#jobnoticeBox').html(t.join(''));
    },
    loadRecruitNotice(data) {
      let t = [];
      t.push(
        `<input type="text" name="jobnoticeSn" id="jobnoticeSn" class="hidden" title="공고명" value="${data.jobnoticeSn}" required />`,
      );
      t.push(`<div style="line-height: 40px">${data.jobnoticeName}</div>`);
      $('#systemKindCode').val(data.systemKindCode);
      $('#jobnoticeBox').html(t.join(''));
    },
    template() {
      let t = [];
      t.push('<section id="loginForm" class="writeResume">');
      t.push('	<div class="subject">');
      t.push('		<label for="jobnoticeSn" class="h2">공고명</label>');
      t.push('		<div class="row in-span no-margin">');
      t.push(
        '			<div class="span per80 like-select" data-name="jobnoticeSn" id="jobnoticeBox">',
      );
      t.push('			</div>');
      t.push(
        '		<input type="hidden" id="systemKindCode" name="systemKindCode" />',
      );
      t.push('	</div>');
      t.push('</div>');
      t.push('	<div class="subject">');
      t.push('		<label for="name" class="h2">성명</label>');
      t.push('		<div class="row in-span no-margin">');
      t.push(
        '			<div class="span per40 alone"><input id="name" name="name" class="text" title="성명" required /></div>',
      );
      t.push('		</div>');
      t.push('	</div>');
      t.push('	<div class="subject">');
      t.push('		<label for="email" class="h2">이메일</label>');
      t.push('		<div class="row in-span no-margin">');
      t.push(
        '			<div class="span per40 alone"><input type="email" id="email" name="email" title="이메일" class="text" required /></div>',
      );
      t.push('		</div>');
      t.push('	</div>');
      t.push('	<div class="subject">');
      t.push('		<label for="password" class="h2">비밀번호</label>');
      t.push('		<div class="row in-span no-margin">');
      t.push(
        '			<div class="span per30"><input type="password" id="password" name="password" maxlength="16" class="text" autocomplete="off" required /></div>',
      );
      t.push(
        '			<div class="span per25"><button type="button" data-button="findPassword" class="btn btn-ng">비밀번호 찾기</button></div>',
      );
      t.push('		</div>');
      t.push('	</div>');
      t.push('</section>');

      return t.join('');
    },
  };

  fn.init();
})();
